import React, { useEffect, useState } from "react";
import SchoolClasses from "./religiousSchools";
import ComingSoon from "components/commingSoon";
import NotAuthorized from "../../components/NotAuthorized";
import "./index.scss";

const ReligiousSchools = () => {
  const [isSchoolActive, setIsSchoolActive] = useState(false);

  let orgInfo = localStorage?.getItem("organization")
    ? JSON.parse(localStorage?.getItem("organization"))
    : [];

  let authorizedModulesInfo = localStorage?.getItem("authorizedModules")
    ? JSON.parse(localStorage?.getItem("authorizedModules"))
    : [];


  useEffect(() => {
    const status = orgInfo?.authorizedModules?.find((item) => item?.moduleName === "education")?.active === true && 
    authorizedModulesInfo?.find((item) => item?.moduleName === "education")?.active === true ? true : false;
    
    setIsSchoolActive(status);
  }, []);

  return !isSchoolActive ? (
    <NotAuthorized title={"School"} />
  ) : (
    <SchoolClasses />
  );
};

export default ReligiousSchools;
